import axios from 'axios';
import {v4 as uuid} from 'uuid';
import toast from '../utils/toast';
import {getLocalData} from "./storageManager";
import Constants from "../utils/constants";

const apiCall = (requestData, requireAuth = false) => {
    return new Promise((resolve, reject) => {
        requestData.params = requestData.params || {};

        let apiHeaders = requestData.headers || {}
        if(requireAuth){
            apiHeaders = {...apiHeaders, ...{"auth-token": getLocalData('token')}}
        }

        const request = {
            url: `${requestData.url}`,
            method: requestData.method || 'GET',
            headers: apiHeaders,
            params: requestData.params,
            data: JSON.stringify(requestData.data || {})
        };

        request.headers['Content-Type'] = 'application/json';
        request.headers['correlation-id'] = uuid();

        axios(request)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                if (error.code === 'ERR_NETWORK') {
                    //server down error
                    toast.error(Constants.ERROR_MESSAGES.ERR_NETWORK)
                } else if (error.code === 'ERR_BAD_RESPONSE') {
                    //internal server error
                    toast.error(Constants.ERROR_MESSAGES.INTERNAL_SERVER)
                } else if (error?.response?.status === 401) {
                    //internal server error
                    toast.error(Constants.ERROR_MESSAGES.SESSION_EXPIRED)
                }
                reject(error.response ? error.response : error);
            });
    });
}

export default apiCall